import { CategoryHeader } from "@repo/components";
import { desktopFallbackBannerImage, mobileFallbackBannerImage } from "@repo/constants/common";
import { shimmer, toBase64 } from "@repo/lib/utils";
import cx from "classnames";
import Image from "next/image";
const ProductTopBanner = ({
  topCategoryDesktopBanners,
  topCategoryMobileBanners,
  categoryName,
  totalCount,
  categorySlug
}) => {
  if (!categorySlug) return;
  return <div className="relative h-[160px] w-full md:h-[310px]" data-sentry-component="ProductTopBanner" data-sentry-source-file="ProductTopBanner.jsx">
      {topCategoryDesktopBanners?.length === 0 && <Image src={desktopFallbackBannerImage} width={1920} height={400} className="hidden size-full object-cover sm:block" alt={categoryName} />}
      <CategoryHeader categoryName={categoryName} totalCount={totalCount} data-sentry-element="CategoryHeader" data-sentry-source-file="ProductTopBanner.jsx" />
      {topCategoryDesktopBanners?.map(banner => <Image src={banner?.imageURI} key={banner?.id} width={banner?.width} height={banner?.height} placeholder={`data:image/svg+xml;base64,${toBase64(shimmer(banner?.width, banner?.height))}`} className={cx("mx-auto h-full w-full object-cover", {
      "hidden sm:block": banner?.imageType === "TOP_DESKTOP"
    })} alt={categoryName} />)}
      {topCategoryMobileBanners?.length === 0 && <Image src={mobileFallbackBannerImage} width={430} height={216} className="size-full object-cover sm:hidden" alt={categoryName} />}
      {topCategoryMobileBanners?.map(banner => <>
          <Image src={banner?.imageURI} width={banner?.width} height={banner?.height} placeholder={`data:image/svg+xml;base64,${toBase64(shimmer(banner?.width, banner?.height))}`} className={cx("mx-auto h-full w-full object-cover", {
        "sm:hidden": banner?.imageType === "TOP_MOBILE"
      })} key={banner?.id} alt={categoryName} />
        </>)}
    </div>;
};
export default ProductTopBanner;